import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import Select from "react-select"
import IntlProps from "../../state/helpers/IntlProps"
import { MCCList } from "./MCCList"

type Props = {
    selectedMcc: string
    onSelect(selectedMcc: number): void
}

const MCCSelect = (props: Props & IntlProps) => {
    const mccOptions = MCCList.map(mccObject => {
        return {
            value: mccObject[0],
            label: props.intl.formatMessage(mccObject[1]),
        }
    })

    const customFilter = (option: { value: number, label: string }, searchText: string) => {
        if (
            option.label.toLowerCase().includes(searchText.toLowerCase()) ||
            String(option.value).includes(searchText.toLowerCase())
        ) {
            return true
        } else {
            return false
        }
    }

    return <Select
        className="mcc-select"
        name={"mcc-select"}
        placeholder={<FormattedMessage
            id="mcc.select_placeholder_label"
            defaultMessage="Select your option"
        />}
        value={props.selectedMcc}
        onChange={(mcc) => { props.onSelect(mcc.value) }}
        options={mccOptions}
        clearable={false}
        searchable={true}
        filterOption={customFilter}
    />
}

export default injectIntl(MCCSelect)


// WEBPACK FOOTER //
// ./src/payment-processing/merchant-onboarding/MCCSelect.tsx